export const COOKIE_LANG = 'lang'
export const COOKIE_DCC = 'dcc'
export const COOKIE_C2P_MC = 'McToken'
export const COOKIE_LAYOUT = 'layout'
export const COOKIE_GCID = 'gcid'
export const COOKIE_CARD_DEPRECIATION_MECHANISM_ACTIVE = 'cdma'
export const COOKIE_CARD_DEPRECIATION_MECHANISM_SHOW_GROUPS = 'cdmsg'
